export default
{
    path: "/ykbnew",
    component: () => import('../view/ykb/ykbNew.vue'),
    props: (route) => ({
        ykbFlowType:route.query.ykbFlowType,
        sapId:route.query.sapId,
        processDefinitionId:route.query.processDefinitionId,
        token:route.query.token,
        userId:route.query.userId,
        secondLoginType:route.query.secondLoginType,
        secondAssessToken:route.query.secondAssessToken,
        deviceId:route.query.deviceId,
    })
}



// WEBPACK FOOTER //
// ./src/router/ykbNewRouter.js